import { Responsive } from 'commons/components';
import {
  MetaplansListDesktopPage,
  MetaplansListMobilePage,
} from './components';

export function MetaplansListPage(): JSX.Element {
  return (
    <Responsive
      mobile={<MetaplansListMobilePage />}
      desktop={<MetaplansListDesktopPage />}
    />
  );
}
